// Put your applicaiton javascript here

// Put your applicaiton javascript here

 /*ESHOP GUIDE*/
/*
 jQuery(function($) {
    window.VIG = window.VIG || {};
    VIG.VariantChangeCallback = function(){
      $('.slick-initialized').each(function(index,slider){
           $(slider).slick("slickFilter",function(){
            if($(this).css("display")!="none"){
              return true;
            }
          });
      })

    };
    VIG.BeforeVariantChange = function(){
      $('.slick-initialized').each(function(index,slider){
           $(slider).slick("slickUnfilter");
      })
    };

 });
 */

$.fn.myElevateZoom = function () {
  $('#zoomed img').removeData('elevateZoom');
  $('.zoomWrapper img.zoomed').unwrap();
  $('.zoomContainer').remove();

  if ($(window).width() > 767) {
    $(this).elevateZoom({
      // custom options here
    });
  }
};

$(document).ready(function(){
  // サムネイル選択時の動作
  $('.product_images .product-photo-thumbs').click(function(){

    $('.product_images .slick-slide').removeClass("slick-current");
    $(this).addClass("slick-current");
   	var index = $(this).parents('.slick-slide').index();

    $(".product_details_slider").slick("slickGoTo",index);
    console.log("index:"+index);
    /*
    $('.product_details_slider .product-photo-thumbs').eq(index).find('img').okzoom({
      width: 200,
      height: 200,
      round: true,
      background: "#fff",
      backgroundRepeat: "repeat",
      shadow: "0 0 5px #000",
      border: "1px solid black"
    });    */
    $('.product_details_slider .product-photo-thumbs').eq(index).find('img').myElevateZoom();
//    $('.product_details_slider .product-photo-thumbs').eq(index).find('img').elevateZoom();

  });

});
  /*ESHOP GUIDE END*/



//以下、トップページのスライドやメニューが動かなくなっていたのでコメントアウトしました。



// Put your applicaiton javascript here

$( document ).ready(function() {
      // 商品詳細用サムネイル一覧用スライダー



      // 商品詳細用大画像スライダー
      $('.product_details_slider').slick({
          arrows:true,
            autoplay:false,
            autoplaySpeed:8000,
            pauseOnHover:false,
            pauseOnFocus:false,
            speed:500,
          //  asNavFor: '.product_images',
          appendArrows: $('#arrows'),
        infinite: false
        });
      // 商品詳細用サムネイル一覧用スライダー
      $('.product_images').slick({
        dots: false,
        arrows:false,
        slidesToShow: 4,
        focusOnSelect: true,
        asNavFor: '.product_details_slider',
        infinite: false

        });

       show_only_current_image(current_loft);


  // 拡大鏡のセットアップ
//  $('.product_details_slider .product-photo-thumbs img').elevateZoom();
    $('.product_details_slider .product-photo-thumbs').eq(0).find('img').myElevateZoom();

    $(document).ready(function(){
      // サムネイル選択時の動作
      $('.product_images .product-photo-thumbs').click(function(){

        $('.product_images .slick-slide').removeClass("slick-current");
        $(this).addClass("slick-current");
       	var index = $(this).parents('.slick-slide').index();

        $(".product_details_slider").slick("slickGoTo",index);
        console.log("index:"+index);
        /*
        $('.product_details_slider .product-photo-thumbs').eq(index).find('img').okzoom({
          width: 200,
          height: 200,
          round: true,
          background: "#fff",
          backgroundRepeat: "repeat",
          shadow: "0 0 5px #000",
          border: "1px solid black"
        });    */
        $('.product_details_slider .product-photo-thumbs').eq(index).find('img').myElevateZoom();
    //    $('.product_details_slider .product-photo-thumbs').eq(index).find('img').elevateZoom();

      });

    });





   // ロフト選択時の動作
   var option_selector = "#ProductSelect-product-template";
   $(option_selector).change(function() {
     current_loft = $( option_selector + ' option:selected').text().trim();
	 show_only_current_image(current_loft);
     $('.product_details_slider .product-photo-thumbs').eq(0).find('img').myElevateZoom();
   })

   function show_only_current_image(current_loft){
    current_alt_prefix = current_loft.toLowerCase().replace('/', '-');
          console.log(current_alt_prefix);
      $('.slick-initialized').each(function(index,slider){

        $(slider).slick("slickUnfilter");
        $(slider).find("img").each(function(i, elem) {
          if($(elem).attr("alt").indexOf(current_alt_prefix) === 0){
            $(elem).parent().parent().parent().addClass("showSlide");
          }else{
            $(elem).parent().parent().parent().removeClass("showSlide");
          }
        });

        $(slider).slick("slickFilter",function(index){

          if($(this).hasClass("showSlide")){
             return true;
          }

        });
      });



   }


  function sanitize_variation(){
    var hide_color = {};
    for(let i = 0; i < product_variants_removed.length; i++) {
      var result = product_variants_removed[i].split('/');
      var key_color = result[0].trim();
      var key_size = result[1].trim();
      if( !hide_color[key_color]){
        hide_color[key_color] = [];
      }
      hide_color[key_color].push(key_size);
     console.log(key_color);
     console.log(key_size);
	}
	return hide_color;
  }
});

//商品ページスライダー及びサムネイル画像の設定--202001
$(function(){
var slider = ".ProductPage__mainSlider"; // スライダー
var thumbnailItem = ".ProductPage__sliderThumbnailItem"; // サムネイル画像アイテム

// サムネイル画像アイテムに data-index でindex番号を付与
$(thumbnailItem).each(function(){
 var index = $(thumbnailItem).index(this);
 $(this).attr("data-index",index);
});

// スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
// 「slickスライダー作成」の前にこの記述は書いてください。
$(slider).on('init',function(slick){
 var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
 $(thumbnailItem+'[data-index="'+index+'"]').addClass("thumbnail-current");
});

//slickスライダー初期化
$(slider).slick({
  autoplay:false,
  autoplaySpeed:8000,
  pauseOnHover:false,
  pauseOnFocus:false,
  speed:500,
  infinite: false
});
//サムネイル画像アイテムをクリックしたときにスライダー切り替え
$(thumbnailItem).on('click',function(){
  var index = $(this).attr("data-index");
  $(slider).slick("slickGoTo",index,false);
  $('.product-photo-thumbs').eq(index).find('img').myElevateZoom();

});

//サムネイル画像のカレントを切り替え
$(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide){
  $(thumbnailItem).each(function(){
    $(this).removeClass("thumbnail-current");
  });
  $(thumbnailItem+'[data-index="'+nextSlide+'"]').addClass("thumbnail-current");
});
});

//拡大鏡の設定--iron
$(document).ready(function(){
//  console.log($('.ProductPage__mainSlider .product-photo-thumbs').eq(0).find('img'));
  $('.product-photo-thumbs').eq(0).find('img').myElevateZoom();

});


// Put your applicaiton javascript here

 /*ESHOP GUIDE*/
/*
 jQuery(function($) {
    window.VIG = window.VIG || {};
    VIG.VariantChangeCallback = function(){
      $('.slick-initialized').each(function(index,slider){
           $(slider).slick("slickFilter",function(){
            if($(this).css("display")!="none"){
              return true;
            }
          });
      })

    };
    VIG.BeforeVariantChange = function(){
      $('.slick-initialized').each(function(index,slider){
           $(slider).slick("slickUnfilter");
      })
    };

 });

$(document).ready(function(){

 $('.product_images .product-photo-thumbs').click(function(){


     $('.product_images .slick-slide').removeClass("slick-current");
     $(this).addClass("slick-current");
   	 var index = $(this).parents('.slick-slide').index();

     $(".product_details_slider").slick("slickGoTo",index);
   });

 });
 */
  /*ESHOP GUIDE END*/
